// Modules
import React from 'react';

// Components
import AlertMessage from './AlertMessage';

// Styling
import './alertMessage.scss';
import { connect } from 'react-redux';
import withRouter from '../../../hoc/withRouter';

// Constants
const ALERT_TTL_IN_MILLISECONDS = 5 * 1000;

class AlertPopupsView extends React.Component {
    alertTimer = false;

    componentDidUpdate() {
        if (this.props.alerts && !this.alertTimer) {
            this.alertTimer = true;

            // Delete the alert from the DOM after 5 seconds
            setTimeout(() => {
                this.props.resetAlerts();
                this.alertTimer = false;
            }, ALERT_TTL_IN_MILLISECONDS);
        }
    }

    handleAlertDismiss = () => {
        this.props.resetAlerts();
    };

    render() {
        return (
            <div className="alerts-container">
                <React.Fragment>
                    {this.props.alerts ? (
                        <div className="alerts-container">
                            {this.props.alerts.errors.map((error, index) => (
                                <div key={index}>
                                    <AlertMessage
                                        type="error"
                                        message={error.message}
                                        onClose={this.handleAlertDismiss}
                                    />
                                </div>
                            ))}
                            {this.props.alerts.successes.map((success, index) => (
                                <div key={index}>
                                    <AlertMessage
                                        type="success"
                                        message={success.message}
                                        onClose={this.handleAlertDismiss}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : null}
                </React.Fragment>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    alerts: state.appData.alerts,
});

const mapDispatchToProps = {
    resetAlerts: () => ({ type: 'RESET', dataType: 'alerts' }),
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlertPopupsView));
